import { render, staticRenderFns } from "./DepartmentConfig.vue?vue&type=template&id=2d429bf5&scoped=true"
import script from "./DepartmentConfig.vue?vue&type=script&lang=js"
export * from "./DepartmentConfig.vue?vue&type=script&lang=js"
import style0 from "./DepartmentConfig.vue?vue&type=style&index=0&id=2d429bf5&prod&lang=stylus"
import style1 from "./DepartmentConfig.vue?vue&type=style&index=1&id=2d429bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d429bf5",
  null
  
)

export default component.exports